import React from 'react';
import './InstallPrompt.css'; // Optional: Add custom styling for the prompt

const InstallPrompt = ({ onInstall, onCancel, isIos }) => {
    return (
        <div className="install-prompt">
            {!isIos ? (
                // Default behavior for platforms that support the `beforeinstallprompt` event
                <>
                    <p>Tap "Add to Home Screen" to install this site as an app! Enjoy easy, one-tap access right from your home screen.</p>
                    <div className="install-prompt-buttons">
                        <button className="install-button" onClick={onInstall}>
                            Add to Home Screen
                        </button>
                        <button className="cancel-button" onClick={onCancel}>
                            Cancel
                        </button>
                    </div>
                </>
            ) : (
                // Custom instructions for iOS users
                <>
                    <p>To install this app on your iPhone or iPad:</p>
                    <ol>
                        <li>Tap the <strong>Share</strong> button (box with an arrow pointing up).</li>
                        <li>Scroll down and select <strong>"Add to Home Screen."</strong></li>
                        <li>Customize the app name (if desired), then tap <strong>Add.</strong></li>
                    </ol>
                    <div className="install-prompt-buttons">
                        <button className="cancel-button" onClick={onCancel}>
                            Close
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default InstallPrompt;
